import { RemarkToCodeMapping } from "@industronics/fids-utils";

export const CARGO_SERVICE_TYPE_CODES = ["F", "H", "L", "M", "Q", "V"];

// Remark codes blanked out on the board when the device is registered with the
// POS-AVIATION toggle on (localStorage key `fids_pos_aviation` === "true").
// The flight row still displays — only its remark text is suppressed.
// Add the codes to hide here — an empty list hides nothing.
export const POS_AVIATION_EXCLUDED_REMARK_CODES: RemarkToCodeMapping[] = [
  RemarkToCodeMapping.LAST_BAG,  // CLB
  RemarkToCodeMapping.CAROUSEL_CLOSED,  // CCL
  RemarkToCodeMapping.CAROUSEL_OPEN,  // COP
  RemarkToCodeMapping.GATE_OPEN,  // GOP
  RemarkToCodeMapping.GATE_CLOSED,  // GCL
  RemarkToCodeMapping.BOARDING,  // GBD
  RemarkToCodeMapping.FINAL_CALL,  // GFC
  RemarkToCodeMapping.NEW_GATE,  // GCH
  RemarkToCodeMapping.DESK_OPEN,  // DOP
  RemarkToCodeMapping.REOPEN,  // DRO
  RemarkToCodeMapping.DESK_CLOSED,  // DCL
  RemarkToCodeMapping.RECLOSE,  // DRC
  RemarkToCodeMapping.OPEN_IOP,  // IOP
  RemarkToCodeMapping.CLOSED_ICL,  // ICL
];

// Languages kept in remark translations when POS-AVIATION is on.
// Anything else (e.g. "ar" Arabic, "zh" Chinese) is dropped from the flip rotation.
export const POS_AVIATION_REMARK_LANGS = ["en", "ml"];

// Languages kept in station (destination) translations when POS-AVIATION is on.
// Anything else (e.g. "ar" Arabic, "zh" Chinese) is dropped from the rotation.
export const POS_AVIATION_STATION_LANGS = ["en", "ml"];
